import OrderDetails, { OrderDetailsProps } from './OrderDetails';

export type { OrderDetailsProps };
export default OrderDetails;
